export const comments_3296179 = {"data":{"data":[],"links":{}}}